// Authentication utilities for OAuth integration
const OAUTH_CLIENT_ID = 'bgm15205ecc1c26e8e09';
const OAUTH_AUTHORIZE_URL = 'https://bgm.tv/oauth/authorize';

// Note: Authentication status is managed via localStorage only
// No API calls needed to check auth status

// Get authentication status from localStorage
export const getAuthStatus = () => {
  return localStorage.getItem('isAuthenticated') === 'true';
};

// Set authentication status in localStorage
export const setAuthStatus = (isAuthenticated) => {
  localStorage.setItem('isAuthenticated', isAuthenticated.toString());
};

// Get private search preference from localStorage
export const getPrivateSearchEnabled = () => {
  return localStorage.getItem('privateSearchEnabled') === 'true';
};

// Set private search preference in localStorage
export const setPrivateSearchEnabled = (enabled) => {
  localStorage.setItem('privateSearchEnabled', enabled.toString());
};

// Redirect to Bangumi OAuth authorization
export const redirectToOAuth = () => {
  // Store current URL to return to after OAuth
  localStorage.setItem('oauthReturnUrl', window.location.pathname + window.location.search);
  
  const oauthUrl = `${OAUTH_AUTHORIZE_URL}?client_id=${OAUTH_CLIENT_ID}&response_type=code`;
  window.location.href = oauthUrl;
};

// Handle OAuth callback - exchange code for tokens
export const handleOAuthCallback = async (code) => {
  try {
    const response = await fetch(`/api/oauth/callback/?code=${code}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    const data = await response.json();
    
    if (data.success) {
      console.log('OAuth successful:', data);
      setAuthStatus(true);
      return { success: true, data };
    } else {
      console.error('OAuth failed:', data.error);
      setAuthStatus(false);
      return { success: false, error: data.error };
    }
  } catch (error) {
    console.error('OAuth request failed:', error);
    setAuthStatus(false);
    return { success: false, error: error.message };
  }
};

// Handle private search toggle
export const handlePrivateSearchToggle = (enabled) => {
  if (enabled) {
    // Check if user is authenticated via localStorage
    const isAuthenticated = getAuthStatus();
    
    if (!isAuthenticated) {
      // Not authenticated, redirect to OAuth
      redirectToOAuth();
      return false; // Don't enable private search yet
    } else {
      // Already authenticated, enable private search
      setPrivateSearchEnabled(true);
      return true;
    }
  } else {
    // Disable private search
    setPrivateSearchEnabled(false);
    return true;
  }
};

// Build API URL with user_collection parameter if private search is enabled
export const buildApiUrl = (baseUrl, isPrivate) => {
  if (isPrivate && getPrivateSearchEnabled() && getAuthStatus()) {
    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}user_collection=true`;
  }
  return baseUrl;
};
